import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '1232252005518849';
export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Domain verification meta tags
    const metas: HTMLMetaElement[] = [];
    ['xh9ygvde233gpeteatmy8qndjatqwp', '9nj3o3la8d5ji5wvxqm9035wpn9gu7'].forEach(content => {
      const m = document.createElement('meta');
      m.name = 'facebook-domain-verification';
      m.content = content;
      document.head.appendChild(m);
      metas.push(m);
    });
    // Preconnect to Facebook for faster pixel load
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = 'https://connect.facebook.net';
    document.head.appendChild(preconnect);
    // Skip if already initialized
    if (window.fbq && window.fbq.loaded) return;
    // Standard Meta Pixel base code
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = false;
    n.version = '2.0';
    n.queue = [];
    // Queue init and PageView before script loads
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    // Load the pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => {
      n.loaded = true;
    };
    document.head.appendChild(script);
    // Noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      metas.forEach(m => m.parentNode?.removeChild(m));
      preconnect.parentNode?.removeChild(preconnect);
      metaDesc.parentNode?.removeChild(metaDesc);
      preloadImg.parentNode?.removeChild(preloadImg);
    };
  }, []);
  return null;
}